<template>
  <TextField :label="$tt('guardian_passport')" :rules="[required]" />
</template>

<script setup lang="ts">
const { required } = useValidation();
</script>